interface SkeletonProps {
  /** Extra Tailwind classes (e.g. "w-3/4 h-6") */
  className?: string;
  /** Inline width override */
  width?: string;
  /** Inline height override */
  height?: string;
}

/** Animated pulse placeholder block. Use inside loading states. */
export function Skeleton({ className = '', width, height }: SkeletonProps) {
  return (
    <div className={`animate-pulse bg-gray-200 rounded ${className}`} style={{ width, height }} />
  );
}
